/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Browser: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.1698 19.2149C19.1769 19.2074 19.1841 19.2 19.1915 19.1926C19.1989 19.1852 19.2064 19.1779 19.214 19.1707C20.3639 17.9975 20.3567 16.1143 19.1924 14.95C18.0208 13.7784 16.1213 13.7784 14.9497 14.95C13.7782 16.1215 13.7782 18.021 14.9497 19.1926C16.1138 20.3567 17.9966 20.3641 19.1698 19.2149ZM19.8282 21.2436C17.8869 22.5294 15.2458 22.3171 13.5355 20.6068C11.5829 18.6542 11.5829 15.4884 13.5355 13.5358C15.4882 11.5831 18.654 11.5831 20.6066 13.5358C22.3172 15.2464 22.5292 17.8881 21.2426 19.8295L23.4341 22.021C23.8246 22.4116 23.8246 23.0447 23.4341 23.4353C23.0436 23.8258 22.4104 23.8258 22.0199 23.4353L19.8282 21.2436Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M23 3H18H16H8H6H1C0.734784 3 0.48043 3.10536 0.292893 3.29289C0.105357 3.48043 0 3.73478 0 4V22C0 22.2652 0.105357 22.5196 0.292893 22.7071C0.48043 22.8946 0.734784 23 1 23H10V21H2V6H22V11H24V4C24 3.73478 23.8946 3.48043 23.7071 3.29289C23.5196 3.10536 23.2652 3 23 3ZM3.5 5C3.77614 5 4 4.77614 4 4.5C4 4.22386 3.77614 4 3.5 4C3.22386 4 3 4.22386 3 4.5C3 4.77614 3.22386 5 3.5 5ZM6 4.5C6 4.77614 5.77614 5 5.5 5C5.22386 5 5 4.77614 5 4.5C5 4.22386 5.22386 4 5.5 4C5.77614 4 6 4.22386 6 4.5ZM7.5 5C7.77614 5 8 4.77614 8 4.5C8 4.22386 7.77614 4 7.5 4C7.22386 4 7 4.22386 7 4.5C7 4.77614 7.22386 5 7.5 5Z'
      fill='currentColor'
    />
  </React.Fragment>
)
